export const Entidade = {
  idenEventoCertidao: 0,
  certidao: {
    idenCertidao: 0,
  },
  tipoEventoCertidao: {},
  amparoLegal: {
    idenAmparoLegal: 0,
    descComplementoAmparo: "",
  },
  numrSeqEventoCertidao: 0,
  dataEventoCertidao: new Date().toLocaleDateString(),
  descComplemento: "",
  statEventoCertidao: 0,
  valorEvento: 0,
  valorEventoAnterior: 0,
  valorEventoPos: 0,
  siglaTipoEventoCertidao: "",
  listaAmparoLegalCertidao: [],
  flagPagamentoIntegral: 'N'
};

export const flagPagamentoIntegral = [
  { label: "Total", code: 'S' },
  { label: "Parcial", code: 'N' },
]

const url = "eventocertidoes";

export function buscarTiposQuitacao() {

  return new Promise(function (resolve, reject) {
    window.$http.get(`/tipoeventocertidaos/buscarQuitacao`).then((res) => {
      resolve(res.data);
    })
  })

}


export const salvarQuitacao = (dados) => {
  return new Promise((resolve, reject) => {
    let JsonPost = {
      ...dados,
      idenCertidao: dados.certidao ? dados.certidao.idenCertidao : null,
      descComplemento: dados.descComplemento ? dados.descComplemento : null,
      listaAmparoLegalCertidao: dados.amparoLegal ? dados.amparoLegal : null,
      // siglaTipoEventoCertidao: dados.tipoEventoCertidao && dados.tipoEventoCertidao.siglTipoEventoCertidao ? dados.tipoEventoCertidao.siglTipoEventoCertidao.code : null,
      dataEventoCertidao: dados.dataEventoCertidao ? dados.dataEventoCertidao : null,
      idenEventoCertidao: dados.idenEventoCertidao,
      valorEvento: dados.valorEvento,
      valorEventoAnterior: dados.valorEventoAnterior,
      valorEventoPos: dados.valorEventoPos,
      empresa: dados.empresa,
    };

    if (dados.idenEventoCertidao === 0) {
      window.$http.post(`${url}/quitacao`, JSON.stringify(JsonPost)).then((res) => {
        resolve(res.data);
      });
    } else {
      //   dados.tipoEventoCertidao.siglTipoEventoCertidao = dados.tipoEventoCertidao.siglTipoEventoCertidao.code
      //   dados.listaAmparoLegalCertidao = dados.listaAmparoLegal.map(e =>{
      //    return {
      //       amparoLegal:e
      //    }
      //  })
      // alterarEventoCertidao(JsonPost, resolve);
    }
  });
};